import { Note, TeamPoint } from "common";
import { useMemo } from "react";

export const useNoteTeamPoint = (note: Note): TeamPoint | null => {
  return useMemo(() => note.teamPoints[0] ?? null, [note.teamPoints]);
};
